module.exports = __webpack_public_path__ + "img/photo-02.d1159676.webp";